import React from 'react';
import Button from "../../../../../../components/button/button.jsx";

const Actions = ({save, undo, id, remove, undoDisabled}) => {
    return (
        <div className={"absolute left-[35px] bottom-[0px] flex items-center justify-center gap-2"}>
            <Button onClick={save} className="w-fit whitespace-nowrap" actionFeedbackType='save'>Salvar</Button>
            {id && <Button target="danger" onClick={remove} actionFeedbackType='delete'>Excluir</Button>}
            {id && <Button target="secondary" className={"w-[160px]"} onClick={undo} disabled={undoDisabled}>Descartar alterações</Button>}
        </div>
    );
}

export default Actions;